import React, {useState, useEffect, useContext} from "react";
import { AuthContext } from "../../context/Auth";
import { Link, Navigate, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Header from '../../components/Header';

export const Login = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false)
    const authContext = useContext(AuthContext);
    const { signIn, signed } = authContext;
    const navigate = useNavigate()

    const handleSignIn = async (e) => {
        e.preventDefault();
      
        // Verifica se o telefone ou senha está vazio
        if (!email || !password) {
          toast.error("Opa! Por favor, preencha o e-mail e a senha.");
          return
        }
      
        console.log('Tentando fazer login com:', { email, password });
        const data = {
          email: email.trim(),
          password: password,
        };
      
        try {
          setIsLoading(true);
          console.log('Chamando signIn com dados:', data);
          await signIn(data);
          console.log('Login realizado com sucesso!');
        } catch (error) {
          console.error('Erro detalhado no login:', error);
          let errorMessage = "Ocorreu um erro ao fazer login.";
          
          if (error.message) {
            errorMessage = error.message;
          } else if (error.response?.data?.msg) {
            errorMessage = error.response.data.msg;
          }
          
          console.log('Mensagem de erro:', errorMessage);
          toast.error(errorMessage);
        } finally {
          setIsLoading(false);
        }
      };
  
      useEffect(() => {
        if (signed) {
            navigate('/dashboard')
        }
    }, [signed]);
  


    return(
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="w-full max-w-sm lg:max-w-md mx-auto">
                <div className="bg-white shadow-lg rounded-lg px-6 lg:px-8 pt-8 pb-6 lg:pb-8">
                    <div className="text-center mb-6">
                        <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">Painel Administrativo</h1>
                        <p className="text-sm lg:text-base text-gray-600">Faça login para continuar</p>
                    </div>
                    
                    <form className="space-y-4 lg:space-y-6">
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                                Email
                            </label>
                            <input 
                                className="shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-blue-500" 
                                id="email" 
                                type="email" 
                                placeholder="email@gmail.com" 
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                                Senha
                            </label>
                            <input 
                                className="shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-blue-500" 
                                id="password" 
                                type="password" 
                                placeholder="******************" 
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <div className="pt-2">
                            <button 
                                className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline transition-colors duration-200" 
                                type="button" 
                                onClick={handleSignIn}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Entrando...' : 'Entrar'}
                            </button>
                        </div>
                        <div className="text-center">
                            <p className="text-xs lg:text-sm text-gray-600">
                                Apenas administradores podem acessar este painel
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}